export default __webpack_public_path__ + "static/media/new2.31de4e9d.jpg";